export default "__VITE_ASSET__MaumEAEl__"